// Tab "Giao diện" của trang Bản đồ giao diện (chỉ Super): mạng → trang → phần tử bấm/gõ được, lấy từ khảo sát của bot.
// Mọi chữ từ máy chủ/tệp khảo sát (nhãn, selector, thuộc tính, tên thao tác) chỉ vào textContent qua h() — nhãn chứa thẻ HTML hiện dạng chữ.
// Bảng nằm trong .tbl (cuộn ngang); chuỗi dài bị cắt + giữ nguyên trong title; mọi lần tải đều có gen() chống vẽ chồng khi bấm nhanh.
import { api, errMsg } from "../api";
import { busy, clear, gen, h } from "../dom";
import { fmtTime } from "../format";
import type { DoiGD, PhanTuGD, TrangGD, TrangThaiPhanTuGD } from "../../../../src/shared/ban-do";

interface NenGD { ma: string; ten: string; soTrang: number; soPhanTu: number; capNhatLuc: string | null; soDoi: number; soKhongTin?: number }

// L-87 (bổ sung): lần khảo sát mới nhất của trang KHÔNG TIN ĐƯỢC (captcha / trang đăng nhập / không mở được đúng trang / phần tử tụt mạnh) →
// phần tử giữ trạng thái lần tin được trước; nói rõ để Super không hiểu nhầm là giao diện đổi.
function tagKhongTin(t: TrangGD): HTMLElement | null {
  const k = t.khongTin;
  if (!k) return null;
  return h("div", { class: "small bdg-wrap", "data-testid": "bdg-khong-tin", title: `Lần khảo sát ${fmtTime(k.luc) || k.luc}: ${k.soPhanTu} phần tử (lần trước ${k.soCu}). Không dùng để so — phần tử giữ trạng thái của lần khảo sát tin được trước đó, không bị tính là “mất”.` },
    h("span", { class: "tag warn" }, "khảo sát mới nhất không tin được"), ` ${k.lyDo}`);
}
interface KqPhanTu { trang: TrangGD; phanTu: PhanTuGD[]; tong: number; trangSo: number; co: number }

const CO = 100; // số phần tử mỗi trang của bảng
const NHAN_TT: Record<TrangThaiPhanTuGD, string> = { con: "còn", mat: "mất", moi: "mới" };
const TIP_TT: Record<TrangThaiPhanTuGD, string> = {
  con: "Còn ở lần khảo sát mới nhất",
  mat: "Có ở lần khảo sát trước nhưng KHÔNG còn ở lần mới nhất — thao tác dùng nó có thể hỏng",
  moi: "Mới xuất hiện ở lần khảo sát mới nhất",
};
const CLASS_TT: Record<TrangThaiPhanTuGD, string> = { con: "", mat: "err", moi: "running" };

const enc = encodeURIComponent;

/** Cắt chuỗi dài cho gọn bảng (không cắt giữa một cặp surrogate của emoji); bản đầy đủ đi vào title. */
function cat(s: string | null | undefined, n: number): string {
  const v = String(s ?? "");
  if (v.length <= n) return v;
  let c = v.slice(0, n);
  const last = c.charCodeAt(c.length - 1);
  if (last >= 0xd800 && last <= 0xdbff) c = c.slice(0, -1);
  return `${c}…`;
}
const tip = (s: string | null | undefined): string | undefined => { const v = String(s ?? ""); return v ? (v.length > 2000 ? `${v.slice(0, 2000)}…` : v) : undefined; };

export async function renderGiaoDienTab(root: HTMLElement): Promise<() => void> {
  let huy = false;
  let dsNen: NenGD[] = [];
  let dsTrang: TrangGD[] = [];
  let nen = "";
  let trangMa: string | null = null;
  let q = "";
  let tt: "" | TrangThaiPhanTuGD = "";
  let soTrangPt = 1;
  let daVe = false; // đã có dữ liệu trên màn → lần tải lại không xoá thành "Đang tải…" (tránh nhấp nháy)

  // ---------- khung ----------
  const btnTai = h("button", { type: "button", class: "mini", title: "Tải lại danh sách mạng, trang và phần tử từ máy chủ", "data-testid": "bdg-reload" }, "Tải lại");
  const btnCopy = h("button", { type: "button", class: "pri", disabled: true, title: "Sao chép bản tóm tắt gọn (trang → phần tử có nhận dạng bền) của mạng đang chọn để dán cho AI", "data-testid": "bdg-copy" }, "Copy tóm tắt cho AI");
  const copyInfo = h("span", { class: "small muted", role: "status", "data-testid": "bdg-copy-info" });
  const copyBox = h("div", { class: "bdg-copy-box", "data-testid": "bdg-copy-box" });
  const info = h("p", { class: "muted small", "data-testid": "bdg-info" }, "Đang tải…");
  const loiBox = h("div", { class: "err-box", hidden: true, role: "alert", "data-testid": "bdg-error" });
  const trongBox = h("div", { class: "card bdg-empty", hidden: true, "data-testid": "bdg-empty" });
  const tabsNen = h("div", { class: "bdg-tabs", role: "tablist", "data-testid": "bdg-tabs" });
  const trangBox = h("div", { class: "bdg-section", "data-testid": "bdg-pages-box" });
  const ptTieuDe = h("h3", { "data-testid": "bdg-el-title" });
  const tim = h("input", { type: "search", placeholder: "Lọc theo chữ hiển thị, selector, thuộc tính…", title: "Gõ một phần nhãn, selector hay thuộc tính của phần tử để lọc", "data-testid": "bdg-search" });
  const chonTt = h("select", { title: "Chỉ xem phần tử còn / mất / mới so với lần khảo sát liền trước", "aria-label": "Lọc theo trạng thái", "data-testid": "bdg-status" },
    h("option", { value: "" }, "Mọi trạng thái"), h("option", { value: "con" }, "Còn"), h("option", { value: "mat" }, "Mất"), h("option", { value: "moi" }, "Mới"));
  const ptThan = h("div", { "data-testid": "bdg-el-body" });
  const ptBox = h("div", { class: "bdg-section card", hidden: true, "data-testid": "bdg-elements" },
    ptTieuDe, h("div", { class: "bdg-filter" }, tim, chonTt), ptThan);
  const doiBox = h("div", { class: "bdg-section card", "data-testid": "bdg-changes-box" });
  const noiDung = h("div", { hidden: true, "data-testid": "bdg-content" }, tabsNen, trangBox, ptBox, doiBox);

  root.append(
    h("div", { class: "toolbar row" }, h("h3", { class: "bdg-h" }, "Giao diện các mạng xã hội"), h("span", { class: "grow" }), btnTai, btnCopy),
    h("div", { class: "row" }, copyInfo),
    copyBox, info, loiBox, trongBox, noiDung);

  const baoLoi = (e: unknown): void => { loiBox.textContent = errMsg(e); loiBox.hidden = false; };
  const hetLoi = (): void => { loiBox.hidden = true; loiBox.textContent = ""; };

  // ---------- tổng quan: các mạng ----------
  function veTrong(): void {
    noiDung.hidden = true;
    btnCopy.disabled = true;
    clear(trongBox);
    trongBox.append(
      h("p", {}, h("b", {}, "Chưa có dữ liệu giao diện.")),
      h("p", { class: "small muted" }, "Bản đồ giao diện lấy từ tệp khảo sát của bot (ban-do-giao-dien-*.json). Hãy nhập tệp khảo sát ở tab “Thao tác” (nút “Nhập tệp…”), rồi quay lại tab này."),
      h("button", { type: "button", class: "pri", title: "Chuyển sang tab Thao tác để bấm “Nhập tệp…”", "data-testid": "bdg-goto-thao-tac",
        onclick: () => document.querySelector<HTMLElement>('[data-testid="bd-tab-thao-tac"]')?.click() }, "Sang tab Thao tác để nhập tệp"));
    trongBox.hidden = false;
    info.textContent = "";
  }

  function veTabs(): void {
    clear(tabsNen);
    for (const n of dsNen) {
      const tong = `${n.soTrang} trang · ${n.soPhanTu} phần tử`;
      tabsNen.append(h("button", { type: "button", role: "tab", class: `mini ${nen === n.ma ? "pri" : ""}`, "aria-selected": String(nen === n.ma), "data-testid": `bdg-tab-${n.ma}`,
        title: n.soDoi ? `${tong} — ${n.soDoi} thay đổi giữa các lần khảo sát` : tong, dataset: { doi: String(n.soDoi) },
        onclick: () => { void chonNen(n.ma); } },
      `${n.ten || n.ma} (${n.soTrang} trang · ${n.soPhanTu} phần tử)`, n.soDoi ? h("span", { class: "bdg-warn", "aria-label": `${n.soDoi} thay đổi` }, ` ⚠${n.soDoi}`) : null,
      n.soKhongTin ? h("span", { class: "small muted", "data-testid": "bdg-tab-khong-tin", title: `${n.soKhongTin} trang có lần khảo sát mới nhất không tin được (captcha / chưa đăng nhập / không mở được đúng trang)` }, ` · ${n.soKhongTin} không tin được`) : null));
    }
  }

  async function taiTong(): Promise<void> {
    const con = gen("bdg-tong");
    if (!daVe) info.textContent = "Đang tải…";
    let d: { nenTang: NenGD[] };
    try {
      d = await api<{ nenTang: NenGD[] }>("GET", "/api/ban-do/giao-dien");
    } catch (e) {
      if (!con() || huy) return;
      info.textContent = "Không tải được giao diện";
      baoLoi(e);
      return;
    }
    if (!con() || huy) return;
    hetLoi();
    dsNen = Array.isArray(d?.nenTang) ? d.nenTang : [];
    if (!dsNen.length) { daVe = false; nen = ""; trangMa = null; veTrong(); return; }
    daVe = true;
    trongBox.hidden = true; noiDung.hidden = false;
    const tongTrang = dsNen.reduce((s, n) => s + n.soTrang, 0), tongPt = dsNen.reduce((s, n) => s + n.soPhanTu, 0);
    const moiNhat = dsNen.map((n) => n.capNhatLuc).filter((x): x is string => !!x).sort().pop();
    info.textContent = `${dsNen.length} mạng · ${tongTrang} trang · ${tongPt} phần tử${moiNhat ? ` · khảo sát mới nhất ${fmtTime(moiNhat)}` : ""}`;
    const giu = dsNen.some((n) => n.ma === nen);
    if (!giu) { nen = dsNen[0]!.ma; trangMa = null; }
    veTabs();
    btnCopy.disabled = false;
    await taiNen(true);
  }

  async function chonNen(ma: string): Promise<void> {
    if (ma === nen) return;
    nen = ma; trangMa = null; q = ""; tt = ""; soTrangPt = 1; tim.value = ""; chonTt.value = "";
    clear(copyBox); copyInfo.textContent = "";
    dsTrang = []; clear(trangBox); clear(doiBox); clear(ptThan); // không để dữ liệu của mạng cũ nằm lại trong lúc tải mạng mới
    veTabs();
    await taiNen(false);
  }

  async function taiNen(giu: boolean): Promise<void> {
    ptBox.hidden = !(giu && trangMa);
    await Promise.all([taiDsTrang(), taiDoi(), giu && trangMa ? taiPt() : Promise.resolve()]);
  }

  // ---------- danh sách trang của mạng ----------
  async function taiDsTrang(): Promise<void> {
    const con = gen("bdg-trang");
    const ma = nen;
    if (!dsTrang.length || !trangBox.querySelector("table")) { clear(trangBox); trangBox.append(h("p", { class: "muted", "data-testid": "bdg-pages-loading" }, "Đang tải các trang…")); }
    let d: { nenTang: string; trang: TrangGD[] };
    try {
      d = await api<{ nenTang: string; trang: TrangGD[] }>("GET", `/api/ban-do/giao-dien/${enc(ma)}`);
    } catch (e) {
      if (!con() || huy) return;
      clear(trangBox);
      trangBox.append(h("div", { class: "err-box", role: "alert", "data-testid": "bdg-pages-error" }, `Không tải được danh sách trang: ${errMsg(e)}`));
      return;
    }
    if (!con() || huy) return;
    dsTrang = Array.isArray(d?.trang) ? d.trang : [];
    if (trangMa && !dsTrang.some((t) => t.ma === trangMa)) { trangMa = null; ptBox.hidden = true; }
    veDsTrang();
  }

  function veDsTrang(): void {
    clear(trangBox);
    const ten = dsNen.find((n) => n.ma === nen)?.ten || nen;
    trangBox.append(h("h3", {}, `Các trang của ${ten}`, h("span", { class: "small muted", "data-testid": "bdg-pages-count" }, ` · ${dsTrang.length} trang`)));
    if (!dsTrang.length) { trangBox.append(h("p", { class: "empty small", "data-testid": "bdg-pages-empty" }, "Mạng này chưa có trang nào trong khảo sát.")); return; }
    const hang = dsTrang.map((t) => {
      const chon = (): void => { void chonTrang(t.ma); };
      return h("tr", { class: `bdg-page-row ${t.ma === trangMa ? "sel" : ""}`, tabindex: 0, "aria-selected": String(t.ma === trangMa), title: "Bấm để xem các phần tử của trang này", "data-testid": "bdg-page-row",
        dataset: { ma: t.ma, mat: String(t.soMat), moi: String(t.soMoi) }, onclick: chon,
        onkeydown: (e: KeyboardEvent) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); chon(); } } },
      h("td", { class: "bdg-cell", title: tip(t.tieuDe) }, h("b", {}, cat(t.ten || t.ma, 80)), t.tieuDe ? h("div", { class: "small muted" }, cat(t.tieuDe, 100)) : null, tagKhongTin(t)),
      h("td", { class: "bdg-cell bdg-mono small", title: tip(t.url) }, cat(t.url, 120)),
      h("td", { class: "nowrap small" }, fmtTime(t.luc) || "—"),
      h("td", { class: "nowrap", "data-testid": "bdg-page-count" }, String(t.soPhanTu)),
      h("td", {}, t.soMat ? h("span", { class: "tag err", title: "Phần tử có ở lần khảo sát trước nhưng không còn" }, `mất ${t.soMat}`) : h("span", { class: "muted small" }, "0")),
      h("td", {}, t.soMoi ? h("span", { class: "tag running", title: "Phần tử mới xuất hiện ở lần khảo sát mới nhất" }, `mới ${t.soMoi}`) : h("span", { class: "muted small" }, "0")));
    });
    trangBox.append(h("div", { class: "tbl" }, h("table", { class: "bdg-table", "data-testid": "bdg-pages-table" },
      h("thead", {}, h("tr", {}, h("th", {}, "Trang"), h("th", {}, "Địa chỉ"), h("th", {}, "Khảo sát lúc"), h("th", {}, "Phần tử"), h("th", {}, "Mất"), h("th", {}, "Mới"))),
      h("tbody", { "data-testid": "bdg-pages" }, ...hang))));
  }

  async function chonTrang(ma: string): Promise<void> {
    if (ma !== trangMa) { q = ""; tt = ""; tim.value = ""; chonTt.value = ""; }
    trangMa = ma; soTrangPt = 1;
    for (const tr of trangBox.querySelectorAll<HTMLElement>("tr.bdg-page-row")) {
      const on = tr.dataset.ma === ma;
      tr.classList.toggle("sel", on); tr.setAttribute("aria-selected", String(on));
    }
    ptBox.hidden = false;
    await taiPt();
  }

  // ---------- phần tử của một trang ----------
  async function taiPt(): Promise<void> {
    const con = gen("bdg-pt");
    const ma = trangMa, n = nen;
    if (!ma) return;
    if (!ptThan.querySelector("table")) { clear(ptThan); ptThan.append(h("p", { class: "muted", "data-testid": "bdg-el-loading" }, "Đang tải các phần tử…")); }
    const qs = new URLSearchParams();
    if (q) qs.set("q", q);
    if (tt) qs.set("tt", tt);
    if (soTrangPt > 1) qs.set("trang", String(soTrangPt));
    qs.set("co", String(CO));
    let d: KqPhanTu;
    try {
      d = await api<KqPhanTu>("GET", `/api/ban-do/giao-dien/${enc(n)}/${enc(ma)}?${qs}`);
    } catch (e) {
      if (!con() || huy || trangMa !== ma) return;
      clear(ptThan);
      ptThan.append(h("div", { class: "err-box", role: "alert", "data-testid": "bdg-el-error" }, `Không tải được phần tử của trang: ${errMsg(e)}`));
      return;
    }
    if (!con() || huy || trangMa !== ma) return;
    vePt(d);
  }

  function chipThuocTinh(k: string, v: string): HTMLElement {
    return h("span", { class: "bdg-attr", title: tip(`${k}=${v}`), "data-testid": "bdg-attr" }, cat(`${k}=${v}`, 70));
  }

  function vePt(d: KqPhanTu): void {
    const t = d.trang;
    soTrangPt = d.trangSo || 1;
    clear(ptTieuDe);
    ptTieuDe.append(`Phần tử của trang “${cat(t.ten || t.ma, 80)}”`,
      h("span", { class: "small muted bdg-wrap", "data-testid": "bdg-el-head" }, ` · ${t.soPhanTu} phần tử${t.soMat ? ` · ${t.soMat} mất` : ""}${t.soMoi ? ` · ${t.soMoi} mới` : ""} · khảo sát ${fmtTime(t.luc) || "—"}`),
      ...[tagKhongTin(t)].filter((x): x is HTMLElement => x !== null));
    clear(ptThan);
    const soTrang = Math.max(1, Math.ceil((d.tong || 0) / (d.co || CO)));
    const loc = q || tt ? " khớp bộ lọc" : "";
    if (!d.phanTu.length) {
      ptThan.append(h("p", { class: "empty small", "data-testid": "bdg-el-empty" }, q || tt ? "Không có phần tử nào khớp bộ lọc." : "Trang này chưa có phần tử nào."));
      return;
    }
    const hang = d.phanTu.map((p) => {
      const thuocTinh = Object.entries(p.thuocTinh ?? {});
      return h("tr", { class: `bdg-tt-${p.trangThai}`, "data-testid": "bdg-el-row", dataset: { tt: p.trangThai, khoa: p.khoa } },
        h("td", { class: "bdg-cell", title: tip(p.nhan) }, p.nhan ? h("span", { "data-testid": "bdg-el-label" }, cat(p.nhan, 120)) : h("span", { class: "muted small" }, "(không có chữ)")),
        h("td", { class: "small nowrap" }, p.tag, p.vaiTro ? h("span", { class: "muted" }, ` · ${cat(p.vaiTro, 30)}`) : null),
        h("td", { class: "bdg-cell bdg-mono small", title: tip(p.css) }, p.css ? cat(p.css, 140) : "—"),
        h("td", { class: "bdg-cell" }, thuocTinh.length ? h("div", { class: "bdg-attrs" }, ...thuocTinh.slice(0, 6).map(([k, v]) => chipThuocTinh(k, String(v))),
          thuocTinh.length > 6 ? h("span", { class: "small muted", title: tip(thuocTinh.slice(6).map(([k, v]) => `${k}=${v}`).join("\n")) }, `+${thuocTinh.length - 6}`) : null) : h("span", { class: "muted small" }, "—")),
        h("td", {}, h("span", { class: `tag ${CLASS_TT[p.trangThai] ?? ""}`, title: TIP_TT[p.trangThai], "data-testid": "bdg-el-status" }, NHAN_TT[p.trangThai] ?? p.trangThai)),
        h("td", { class: "bdg-cell" }, p.thaoTac?.length ? h("div", { class: "bdg-attrs" }, ...p.thaoTac.map((x) => h("span", { class: "tag", title: tip(x.id), "data-testid": "bdg-used", dataset: { id: x.id } }, cat(x.ma, 40)))) : h("span", { class: "muted small" }, "—")));
    });
    ptThan.append(
      h("div", { class: "tbl" }, h("table", { class: "bdg-table", "data-testid": "bdg-el-table" },
        h("thead", {}, h("tr", {}, h("th", {}, "Nhãn"), h("th", {}, "Loại"), h("th", {}, "Selector (css)"), h("th", {}, "Thuộc tính nhận dạng"), h("th", {}, "Trạng thái"), h("th", { title: "Các thao tác đang dùng phần tử này" }, "Dùng bởi"))),
        h("tbody", { "data-testid": "bdg-el-rows" }, ...hang))),
      h("div", { class: "row bdg-paging", "data-testid": "bdg-paging" },
        soTrang > 1 ? h("button", { type: "button", class: "mini", title: "Về trang phần tử trước", disabled: soTrangPt <= 1, "data-testid": "bdg-prev", onclick: () => { soTrangPt--; void taiPt(); } }, "← Trước") : null,
        h("span", { class: "small", "data-testid": "bdg-page" }, `Trang ${soTrangPt}/${soTrang} · ${d.tong} phần tử${loc}`),
        soTrang > 1 ? h("button", { type: "button", class: "mini", title: "Sang trang phần tử sau", disabled: soTrangPt >= soTrang, "data-testid": "bdg-next", onclick: () => { soTrangPt++; void taiPt(); } }, "Sau →") : null));
  }

  let hen: number | undefined;
  tim.addEventListener("input", () => { window.clearTimeout(hen); hen = window.setTimeout(() => { q = tim.value.trim(); soTrangPt = 1; void taiPt(); }, 250); });
  chonTt.addEventListener("change", () => { tt = chonTt.value as "" | TrangThaiPhanTuGD; soTrangPt = 1; void taiPt(); });

  // ---------- thay đổi gần đây ----------
  async function taiDoi(): Promise<void> {
    const con = gen("bdg-doi");
    const ma = nen;
    if (!doiBox.querySelector("table")) { clear(doiBox); doiBox.append(h("h3", {}, "Thay đổi giao diện gần đây"), h("p", { class: "muted", "data-testid": "bdg-changes-loading" }, "Đang tải…")); }
    let ds: DoiGD[];
    try {
      ds = await api<DoiGD[]>("GET", `/api/ban-do/giao-dien-doi?nenTang=${enc(ma)}`);
    } catch (e) {
      if (!con() || huy) return;
      clear(doiBox);
      doiBox.append(h("h3", {}, "Thay đổi giao diện gần đây"), h("div", { class: "err-box", role: "alert", "data-testid": "bdg-changes-error" }, `Không tải được thay đổi gần đây: ${errMsg(e)}`));
      return;
    }
    if (!con() || huy) return;
    ds = Array.isArray(ds) ? ds : [];
    clear(doiBox);
    const mat = ds.filter((x) => x.loai === "mat").length, moi = ds.length - mat;
    doiBox.append(h("h3", {}, "Thay đổi giao diện gần đây", h("span", { class: "small muted", "data-testid": "bdg-changes-count" }, ds.length ? ` · ${mat} mất · ${moi} mới` : "")));
    if (!ds.length) { doiBox.append(h("p", { class: "empty small", "data-testid": "bdg-changes-empty" }, "Chưa thấy thay đổi nào giữa các lần khảo sát.")); return; }
    doiBox.append(h("div", { class: "tbl" }, h("table", { class: "bdg-table", "data-testid": "bdg-changes-table" },
      h("thead", {}, h("tr", {}, h("th", {}, "Lúc"), h("th", {}, "Trang"), h("th", {}, "Thay đổi"), h("th", {}, "Phần tử"), h("th", { title: "Thao tác dùng phần tử này — có thể bị ảnh hưởng" }, "Thao tác bị ảnh hưởng"))),
      h("tbody", {}, ...ds.map((x) => h("tr", { class: `bdg-doi-${x.loai}`, "data-testid": "bdg-change-row", dataset: { loai: x.loai, trang: x.trang },
        title: "Bấm để mở trang này", style: "cursor:pointer", onclick: () => { void chonTrang(x.trang); } },
      h("td", { class: "nowrap small" }, fmtTime(x.luc) || "—"),
      h("td", { class: "bdg-cell small", title: tip(x.trang) }, cat(x.trang, 60)),
      h("td", {}, h("span", { class: `tag ${x.loai === "mat" ? "err" : "running"}` }, x.loai === "mat" ? "mất" : "mới")),
      h("td", { class: "bdg-cell", title: tip(`${x.nhan}${x.css ? `\n${x.css}` : ""}`) }, h("div", {}, cat(x.nhan, 100) || "(không có chữ)"), x.css ? h("div", { class: "bdg-mono small muted" }, cat(x.css, 100)) : null),
      h("td", { class: "bdg-cell" }, x.thaoTacAnhHuong?.length ? h("div", { class: "bdg-attrs" }, ...x.thaoTacAnhHuong.map((a) => h("span", { class: "tag warn", title: tip(a.id), "data-testid": "bdg-affected", dataset: { id: a.id } }, cat(a.ma, 40)))) : h("span", { class: "muted small" }, "không có"))))))));
  }

  // ---------- copy tóm tắt cho AI ----------
  btnCopy.addEventListener("click", () => void busy(btnCopy, "Đang lấy…", async () => {
    if (!nen) return;
    clear(copyBox);
    copyInfo.className = "small muted";
    copyInfo.textContent = "";
    let van: string;
    try {
      const r = await api<{ van: string }>("GET", `/api/ban-do/giao-dien/${enc(nen)}/tom-tat`);
      van = String(r?.van ?? "");
    } catch (e) {
      copyInfo.className = "small err";
      copyInfo.textContent = `Không lấy được tóm tắt: ${errMsg(e)}`;
      return;
    }
    if (huy) return;
    if (!van) { copyInfo.textContent = "Bản tóm tắt đang trống — mạng này chưa có phần tử nào để tóm tắt."; return; }
    const dai = `${van.length.toLocaleString("vi-VN")} ký tự`;
    try {
      await navigator.clipboard.writeText(van);
      copyInfo.className = "small ok";
      copyInfo.textContent = `Đã copy ${dai} — dán vào cuộc trò chuyện với AI.`;
    } catch {
      copyInfo.className = "small err";
      copyInfo.textContent = `Trình duyệt chặn việc tự copy (${dai}). Nhấn Ctrl+C trong ô bên dưới để sao chép.`;
      const ta = h("textarea", { readonly: true, rows: 8, spellcheck: "false", class: "bd-code", "aria-label": "Bản tóm tắt cho AI", "data-testid": "bdg-copy-text" });
      ta.value = van;
      copyBox.append(ta);
      ta.focus(); ta.select();
    }
  }));

  btnTai.addEventListener("click", () => void busy(btnTai, "Đang tải…", () => taiTong()));

  // Tab này chỉ vẽ một lần; khi người dùng nhập khảo sát mới ở tab Thao tác rồi quay lại, vùng này được bỏ `hidden` → tải lại dữ liệu.
  const quanSat = new MutationObserver(() => { if (!root.hidden && !huy) void taiTong(); });
  quanSat.observe(root, { attributes: true, attributeFilter: ["hidden"] });

  await taiTong();
  return () => { huy = true; quanSat.disconnect(); window.clearTimeout(hen); };
}
